import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-service-points',
    templateUrl: './service-points.component.html',
    styleUrls: ['./service-points.component.scss'],
    standalone: false
})
export class ServicePointsComponent implements OnInit  {
  constructor() { }

  ngOnInit() {
  }
}
